import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ErrorBoundary } from "./components/common/ErrorBoundary/ErrorBoundary";
import { CenteredPageLoader } from "./components/common/CenteredPageLoader/CenteredPageLoader";
import { colorTokens } from "./designTokens";

const AppRehydrationLoader: React.FC = () => (
  <div
    id="app-rehydration-loader"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      backgroundColor: colorTokens["Background/Greyish"],
    }}
  >
    <CenteredPageLoader
      message="Loading session..."
      id="app-rehydration-loader-spinner"
    />
  </div>
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<AppRehydrationLoader />} persistor={persistor}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

/*
  FRONT-041: default collector
  - development → console.debug ([web-vitals])
  - production → POST only when REACT_APP_WEB_VITALS_ENDPOINT is set
  Pass a custom ReportHandler to override.
*/
reportWebVitals();
